/**
 * 自动生成， 请不要手工修改！
 */


export enum ProductStatus {
    ACTIVE,
    IN_REVIEW,
    CANCELLED,
    HIDDEN,
    DISLIKED
}
